<template>
  <div class="controls">
    <div class="controls__left">
      <!--<LayoutButtonGroup>
        <template v-for="actionItem in actions">
          <FormButton
            v-for="action in actionItem.items"
            :key="'ACTION_' + action.name"
            :value="action.name"
            :icon="action.icon"
            :color="action.color"
            :iconSize="action.iconSize"
            @clicked="toggleAction"
            :data-tooltip-location="action.name === 'add' ? 'top-right' : 'top'"
            :data-tooltip="actionItem.label + ' ' + action.label"
          />
        </template>
      </LayoutButtonGroup>-->
    </div>

    <div class="controls__right">
      <LayoutButtonGroup v-for="controlItem in controls">
        <FormButton
          v-for="control in controlItem.items"
          :key="'DATASET_CONTROL_' + control.name"
          :value="getControlItemValue(controlItem, control, false)"
          :icon="getControlItemIcon(controlItem, control)"
          :selected="selectedDatasetControls.chart_type === control.name || selectedDatasetControls.chart_type === control.name[0] || selectedDatasetControls.chart_type === control.name[1] ? true : false"
          :disabled="(control.name === 'img' && selectedDatasetControls.chart_type === 'datatable') || (control.name === 'xls' && !isAuthenticated) ? true : false"
          variant="light"
          :iconSize="control.iconSize"
          @clicked="toggleControl(getControlItemValue(controlItem, control, selectedDatasetControls.chart_type === control.name || selectedDatasetControls.chart_type === control.name[0] || selectedDatasetControls.chart_type === control.name[1] ? true : false))"
          data-tooltip-location="top-left"
          :data-tooltip="getControlItemLabel(controlItem, control, selectedDatasetControls.chart_type === control.name || selectedDatasetControls.chart_type === control.name[0] || selectedDatasetControls.chart_type === control.name[1] ? true : false)"
        />
      </LayoutButtonGroup>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import LayoutButtonGroup from '@/components/layout/ButtonGroup.vue'
import { downloadPost } from '@/helpers/http'

export default {
  components: {
    FormButton,
    LayoutButtonGroup
  },
  props: {
    highlightColor: {
      type: String,
      default: '#1b1e21'
    },
    activeColor: {
      type: String,
      default: '#1593a6'
    }
  },
  data () {
    return {
      controls: [{
        'name': 'chart_type',
        'label': 'Switch to',
        'items': [{
          'name': ['ver_bar', 'hor_bar'],
          'label': ['Vertical Bar Chart', 'Horizontal Bar Chart'],
          'color': 'blue',
          'icon': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M5 19h-4v-8h4v8zm6 0h-4v-18h4v18zm6 0h-4v-12h4v12zm6 0h-4v-4h4v4zm1 2h-24v2h24v-2z"/></svg>',
          'iconSize': 'lg'
        },{
          'name': ['stacked_ver_bar', 'stacked_hor_bar'],
          'label': ['Stacked Vertical Bar Chart', 'Stacked Horizontal Bar Chart'],
          'color': 'blue',
          'icon': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M4 17.162l-2 .838v-12.972l12-5.028v2.507l-10 4.19v10.465zm18-11.162l-12 5.028v12.972l12-5.028v-12.972zm-14 3.697l10-4.19v-2.507l-12 5.028v12.972l2-.838v-10.465z"/></svg>',
          'iconSize': 'lg'
        },{
          'name': ['hor_line', 'ver_line'],
          'label': ['Horizontal Line Chart', 'Vertical Line Chart'],
          'color': 'blue',
          'icon': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M18.799 7.038c-.496-.535-.799-1.252-.799-2.038 0-1.656 1.344-3 3-3s3 1.344 3 3-1.344 3-3 3c-.146 0-.29-.01-.431-.031l-3.333 6.032c.475.53.764 1.231.764 1.999 0 1.656-1.344 3-3 3s-3-1.344-3-3c0-.583.167-1.127.455-1.587l-2.565-3.547c-.281.087-.58.134-.89.134l-.368-.022-3.355 6.069c.451.525.723 1.208.723 1.953 0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3c.186 0 .367.017.543.049l3.298-5.967c-.52-.539-.841-1.273-.841-2.082 0-1.656 1.344-3 3-3s3 1.344 3 3c0 .617-.187 1.191-.507 1.669l2.527 3.495c.307-.106.637-.164.98-.164.164 0 .325.013.482.039l3.317-6.001zm-3.799 7.962c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-6-8c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"/></svg>',
          'iconSize': 'lg'
        },{
          'name': ['pie', 'pie'],
          'label': ['Pie Chart', 'Pie Chart'],
          'color': 'blue',
          'icon': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13.012 5.007v-1.668l2.802-2.771c.409.136.809.293 1.197.471l-3.999 3.968zm7.089-1.93l-7.089 7.058v.853h.877l7.044-7.076c-.263-.292-.541-.57-.832-.835zm-7.089-1.468l1.437-1.406c-.46-.094-.96-.163-1.437-.203v1.609zm10.789 7.962l-1.386 1.417h1.585c-.04-.47-.106-.964-.199-1.417zm-.363-1.366c-.135-.41-.292-.81-.469-1.199l-3.951 3.982h1.668l2.752-2.783zm-1.063-2.337c-.205-.346-.426-.682-.664-1.004l-6.093 6.124h1.668l5.089-5.12zm-3.225-3.57c-.322-.238-.657-.459-1.003-.665l-5.135 5.104v1.668l6.138-6.107zm-8.15 10.702v-13c-6.161.519-11 5.683-11 11.978 0 6.639 5.382 12.022 12.021 12.022 6.296 0 11.46-4.839 11.979-11h-13z"/></svg>',
          'iconSize': 'lg'
        }]
      }]
    }
  },
  computed: {
    selectedDatasetControls () {
      return this.$store.getters['search/getSelectedDatasetControls']
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  methods: {
    async toggleControl (value) {
      if (value === 'xls') {
        this.downloadExcel()
      } else if (value === 'img') {
        this.downloadImage()
      } else {
        this.$store.dispatch('search/toggleDatasetControl', value)
      }
    },
    downloadImage () {
      this.$store.dispatch('app/setIsDownloadingImage', true)
      // REFRESH CANVAS / CREATE NEW FOR THIS?
    },
    getControlItemValue (controlItem, control, flip) {
      let value = ''

      if (this.selectedDatasetControls.chart_type === 'ver_bar' || this.selectedDatasetControls.chart_type === 'stacked_ver_bar' || this.selectedDatasetControls.chart_type === 'hor_line' || this.selectedDatasetControls.chart_type === 'pie' || this.selectedDatasetControls.chart_type === 'datatable') {
        value = Array.isArray(control.name) ? control.name[flip ? 1 : 0] : control.name
      } else {
        value = Array.isArray(control.name) ? control.name[flip ? 0 : 1] : control.name
      }

      return value
    },
    getControlItemIcon (controlItem, control) {
      let icon = ''
      let selected = 0

      if (controlItem.name === 'chart_style') {
        selected = this.selectedDatasetControls.chart_style === 'stacked' ? 1 : 0
        icon = control.icon[selected]
      } else {
        icon = control.icon
      }

      return icon
    },
    getControlItemLabel (controlItem, control, flip) {
      let label = ''

      if (this.selectedDatasetControls.chart_type === 'ver_bar' || this.selectedDatasetControls.chart_type === 'stacked_ver_bar' || this.selectedDatasetControls.chart_type === 'hor_line' || this.selectedDatasetControls.chart_type === 'pie' || this.selectedDatasetControls.chart_type === 'datatable') {
        label = Array.isArray(control.label) ? controlItem.label + ' ' + control.label[flip ? 1 : 0] : controlItem.label + ' ' + control.label
      } else {
        label = Array.isArray(control.label) ? controlItem.label + ' ' + control.label[flip ? 0 : 1] : controlItem.label + ' ' + control.label
      }

      return label
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.controls {
  display: flex;
  justify-content: space-between;
  margin: 0 8px;
  height: 36px;

  @media screen and (min-width: $breakpointLg) {
    height: 40px;
  }

  &__left {
    display: flex;
  }

  &__right {
    display: flex;
  }
}
</style>
